import axios from "axios";
import URL, { portalId } from "../api";
import {
  GET_USERS_FAIL,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  LOGIN_USER_FAIL,
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGOUT,
  REGISTER_USER_FAIL,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
} from "../types";
import { getProfileInfo } from "./profileActions";

export const loginUser = (user) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER_REQUEST });
    // dispatch({ type: RESET_AUTH });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log({ user });
    const { data } = await axios.post(URL + "/users/login", user, config);

    localStorage.setItem(
      "user_info",
      JSON.stringify({ ...data, authenticated: true })
    );
    dispatch({ type: LOGIN_USER_SUCCESS, payload: data });
    // dispatch(getProfileInfo())
  } catch (error) {
    dispatch({
      type: LOGIN_USER_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(error);
  }
};

export const registerUser = (user) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_USER_REQUEST });
    // dispatch({ type: RESET_AUTH });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log({ user });
    const { data } = await axios.post(URL + "/users/register", user, config);

    localStorage.setItem(
      "user_info",
      JSON.stringify({ ...data, authenticated: true })
    );
    dispatch({ type: REGISTER_USER_SUCCESS, payload: data });
    // dispatch(getProfileInfo())
  } catch (error) {
    dispatch({
      type: REGISTER_USER_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
    console.log(error);
  }
};

export const getUsers = () => async (dispatch) => {
  try {
    dispatch({ type: GET_USERS_REQUEST });

    const { data } = await axios.get(URL + "/users");

    dispatch({ type: GET_USERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_USERS_FAIL,
      payload: error.response && error.response.data,
    });
    console.log(error);
  }
};

export const logout = (msg) => (dispatch) => {
  dispatch({ type: LOGOUT, payload: msg });
  localStorage.removeItem("user_info");
};
